"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
const SvgComponent = (props, ref) => /*#__PURE__*/React.createElement("svg", (0, _extends2.default)({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 48 48",
  ref: ref
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "var(--sds--ursa-icons--background-color, transparent)",
  d: "M15.009 7.76H10.7a7 7 0 0 0-7 7v18.48a7 7 0 0 0 7 7h26.6a7 7 0 0 0 7-7V17.95a7 7 0 0 0-7-7H23.651a6 6 0 0 1-3.463-1.102l-1.138-.804a7 7 0 0 0-4.041-1.284"
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M15.009 9.56H10.7a5.2 5.2 0 0 0-5.2 5.2v18.48a5.2 5.2 0 0 0 5.2 5.2h26.6a5.2 5.2 0 0 0 5.2-5.2V17.95a5.2 5.2 0 0 0-5.2-5.2H23.651a7.8 7.8 0 0 1-4.502-1.432l-1.138-.804a5.2 5.2 0 0 0-3.002-.954M10.7 7.76h4.309a7 7 0 0 1 4.041 1.284l1.138.804a6 6 0 0 0 3.463 1.101h13.65a7 7 0 0 1 7 7v15.29a7 7 0 0 1-7 7H10.7a7 7 0 0 1-7-7V14.76a7 7 0 0 1 7-7",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M25.717 21.605a3.805 3.805 0 1 0 7.61 0 3.805 3.805 0 0 0-7.61 0",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M11.822 31.774a4.88 4.88 0 0 1 4.879-4.878h3.561a4.88 4.88 0 0 1 4.878 4.878c0 .809-.655 1.464-1.463 1.464H13.286a1.464 1.464 0 0 1-1.464-1.464m14.317 1.464h8.58c.807 0 1.463-.655 1.463-1.464a4.88 4.88 0 0 0-4.879-4.878h-3.561c-.997 0-1.924.299-2.696.812a6.25 6.25 0 0 1 1.495 4.066 2.85 2.85 0 0 1-.402 1.464"
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M24.002 33.202a1.464 1.464 0 0 1-1.139-1.428c0-1.192.428-2.285 1.139-3.132a4.86 4.86 0 0 1 1.139 3.132c0 .697-.487 1.28-1.139 1.428"
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M14.675 21.605a3.805 3.805 0 1 0 7.61 0 3.805 3.805 0 0 0-7.61 0",
  clipRule: "evenodd"
}));
const ForwardRef = /*#__PURE__*/(0, _react.forwardRef)(SvgComponent);
var _default = ForwardRef;
exports.default = _default;
//# sourceMappingURL=WorkspacesIcon48.js.map